import { GET_DASHBOARD, ERR_DASHBOARD } from "../actions/actionTypes";

const initialState = {
	dashboard: {users:{total:'',active:''},
	brands:{total:'',active:''},
	campaigns:{total:'',active:''},
	collections:{total:'',active:''},
	offerings:{total:'',active:''}
},
	loading: true,
	errors: {},
};

export default function dashboardReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GET_DASHBOARD:
			return {
				...state,
				dashboard: payload,
				loading: false,
			};
		case ERR_DASHBOARD:
			return {
				...state,
				error: payload,
				loading: false,
				profile: null,
			};
		default:
			return state;
	}
}
